import { Capacitor } from '@capacitor/core';

/**
 * One place that answers "where are we running?".
 *
 * The same bundle ships as a web page, as an installed PWA and as a native app.
 * Most of the client should not care — but the few places that do (haptics,
 * push, the status bar, how the back button behaves) should ask here rather
 * than each sniffing the user agent their own way.
 */

export type Platform = 'web' | 'ios' | 'android';

export const platform: Platform = Capacitor.getPlatform() as Platform;

/** True inside the Capacitor shell. False in a browser, including an installed PWA. */
export const isNative: boolean = Capacitor.isNativePlatform();

/** True when launched from the home screen as a PWA. */
export const isStandalone: boolean =
  typeof window !== 'undefined' &&
  (window.matchMedia('(display-mode: standalone)').matches ||
    // iOS Safari predates the media query.
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true);

/** Whether a Capacitor plugin is actually available before calling into it. */
export function hasPlugin(name: string): boolean {
  return Capacitor.isPluginAvailable(name);
}
